import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { DoubleClickAd } from "js/legacy/components/results-doubleclick-ad";
import IconGridBase from "icons/IconGrid";

import lingoAdSrc from "img/ads/lingo-600x100.png";

import { convertPxToRem } from "frontend/components/helpers";

const LingoAdImage = styled.img.attrs({
    src: lingoAdSrc
})`
    display: block;
    margin: 0 auto;
    max-width: ${convertPxToRem({ px: 300 })};
    width: 100%;
    max-height: ${convertPxToRem({ px: 50 })};
`;

export const LingoAd = () => (
    <a href="https://www.lingoapp.com/?utm_source=noun_project" target="_blank">
        <LingoAdImage />
    </a>
);

let SquarespaceAd = ({ className }) => {
    return (
        <div className={className}>
            <DoubleClickAd />
        </div>
    );
};

SquarespaceAd.propTypes = {
    className: PropTypes.string
};

SquarespaceAd = styled(SquarespaceAd)`
    iframe {
        margin-top: 0 !important;
        display: block;
    }
`;

export { SquarespaceAd };

export const AdContainer = styled.div.attrs({
    "data-testid": "icon-grid-ad"
})`
    margin-top: ${convertPxToRem({ px: 24 })};
`;

export const IconGrid = styled(IconGridBase)`
    ${AdContainer} + & {
        margin-top: ${convertPxToRem({ px: 24 })};
    }
`;
